import React, { useState } from "react";
import { Input, Collapse, Typography, Card, Modal } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import {
  Container,
  FaqList,
  SearchContainer,
  RoundedButton,
  ButtonContainer,
} from "./styles";
import { toast } from "react-toastify";
import api from "../../../services/api";
import { ViewInput } from "../../../GlobalStyles";
import { useAuth } from "../../../hooks/AuthContext";
import { useSocket } from "../../../hooks/SocketContext";

const { Title } = Typography;
const { Panel } = Collapse;

const HelpCenter = () => {
  const { user } = useAuth();
  const { socket } = useSocket();
  const [searchTerm, setSearchTerm] = useState("");
  const [ask, setAsk] = useState("");
  const [response, setResponse] = useState("");
  const [showResult, setShowResult] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isLoadingModal, setIsLoadingModal] = useState(false);
  const [message, setMessage] = useState("");

  const faqs = [
    {
      key: "1",
      question: "Como eu solicito uma nova Ordem de Serviço (OS)?",
      answer:
        'No menu lateral, clique em "Solicitar OS". Você será direcionado para a página de criação de uma nova Ordem de Serviço.',
    },
    {
      key: "2",
      question: "Onde posso ver o andamento das minhas OSs?",
      answer:
        'Acesse a opção "Minhas OSs" no menu para listar todas as suas Ordens de Serviço e verificar o status de cada uma.',
    },
    {
      key: "3",
      question: "Como funciona a compra de leads?",
      answer:
        'Vá para "Área de Marketing" no menu. Lá você poderá ver os leads disponíveis e adquiri-los usando o saldo da sua carteira.',
    },
    {
      key: "4",
      question: "Onde eu vejo os leads que já adquiri?",
      answer:
        'No menu, clique em "Meus Leads". Essa página lista todos os leads que você comprou e suas informações de contato.',
    },
    {
      key: "5",
      question: "Como posso adicionar saldo à minha carteira?",
      answer:
        'Acesse "Minha Carteira" e procure pela opção de "Adicionar Saldo". Você poderá gerar um boleto ou QR Code para pagamento.',
    },
    {
      key: "6",
      question: "Onde encontro meu extrato financeiro?",
      answer:
        'Clique em "Financeiro" no menu lateral para ter acesso a todo o seu histórico de transações, faturas e extratos.',
    },
    {
      key: "7",
      question: "O que é a Área do Conhecimento?",
      answer:
        'É nossa plataforma de E-learning. Acesse "Área do Conhecimento" no menu para encontrar cursos e treinamentos sobre nossos produtos e serviços.',
    },
    {
      key: "8",
      question: "Como acesso o CRM para gerenciar meus clientes?",
      answer:
        'Clique no item "CRM" no menu para abrir a ferramenta de Gestão de Relacionamento com o Cliente, onde você pode organizar seus contatos e negociações.',
    },
    {
      key: "9",
      question: "Onde posso consultar meus contratos?",
      answer:
        'Seus contratos com a Guruseg podem ser visualizados na seção "Contratos" no menu lateral.',
    },
    {
      key: "10",
      question: "Para que serve o Formulário de Levantamento?",
      answer:
        'Esta ferramenta, acessível pelo menu "Formulário de Levantamento", serve para coletar informações técnicas detalhadas para projetos ou instalações complexas.',
    },
  ];

  async function getAssistent(ask) {
    setIsLoading(true);
    setShowResult(false);
    await api
      .get(`/ia/assistent?ask=${ask}`)
      .then((response) => {
        setResponse(response.data);
        setSearchTerm("");
        setAsk(ask);
        setShowResult(true);
      })
      .catch(({ response }) => {
        if (response) {
          if (response.data) {
            if (response.data.message) {
              toast.warn(response.data.message);
            } else {
              toast.warn(
                "Erro Interno. verifique sua conexão e tente novamente"
              );
            }
          } else {
            toast.warn("Erro Interno. verifique sua conexão e tente novamente");
          }
        } else {
          toast.warn("Erro Interno. verifique sua conexão e tente novamente");
        }
      });
    setIsLoading(false);
  }

  async function openTicket() {
    setIsLoadingModal(true);
    if (!message) {
      toast.warn("Escreva sua duvida para abrir um chamado");
      setIsLoadingModal(false);
    } else {
      const chatSend = {
        send_type: user.type,
        content: message,
      };
      socket.emit("newChat", chatSend, (response) => {
        if (response.status === "ok") {
          setMessage("");
          setIsModalVisible(false);
          toast.success("Chamado aberto com sucesso, aguarde um atendente");
        } else {
          console.log(response);
          toast.warn(
            response.message || "Falha ao abrir chamado. Tente novamente."
          );
        }

        setIsLoadingModal(false);
      });
    }
  }

  return (
    <Container>
      <Title level={2}>Central de Ajuda</Title>
      <SearchContainer>
        <Input
          placeholder="Digite sua dúvida"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
        <RoundedButton
          loading={isLoading}
          type="primary"
          icon={<SearchOutlined />}
          onClick={() => {
            getAssistent(searchTerm);
          }}
        >
          Pesquisar
        </RoundedButton>
      </SearchContainer>

      {showResult && (
        <Card title={ask} style={{ marginBottom: "2rem" }}>
          <p
            style={{
              whiteSpace: "pre-wrap",
              wordWrap: "break-word",
            }}
          >
            {response}
          </p>
        </Card>
      )}

      <Title level={4}>Principais Dúvidas</Title>
      <FaqList>
        {faqs.map((faq) => (
          <Collapse key={faq.key}>
            <Panel header={faq.question} key={faq.key}>
              <p>{faq.answer}</p>
            </Panel>
          </Collapse>
        ))}
      </FaqList>

      <ButtonContainer
        onClick={() => {
          setIsModalVisible(true);
          setMessage("");
        }}
      >
        <RoundedButton type="primary">Abrir Chamado</RoundedButton>
      </ButtonContainer>

      <Modal
        title="Abertura de Chamado"
        open={isModalVisible}
        isLoading={isLoadingModal}
        onOk={() => {
          openTicket();
        }}
        onCancel={() => {
          setIsModalVisible(false);
        }}
        okText="Abrir Chamado"
        cancelText="Cancelar"
      >
        <ViewInput style={{ margin: "15px 0" }}>
          <p>Escreva sua dúvida</p>
          <Input.TextArea
            value={message}
            onChange={(text) => {
              setMessage(text.target.value);
            }}
            style={{ minHeight: 80 }}
          />
        </ViewInput>
        <p>Horário de Atendimento</p>
        <p>Segunda a Sexta</p>
        <p> 8hrs as 12hrs / 14hrs as 18hrs</p>
      </Modal>
    </Container>
  );
};

export default HelpCenter;
